import Background from './background';

export default function HomePage() {
  return (
    <main className="home-page">
      <Background />
      <section className="home-intro" aria-labelledby="home-intro-title">
        <p id="home-intro-title" className="home-intro__eyebrow">
          Welcome to my website
        </p>
        <p className="home-intro__copy">
          I'm Cray Carlton. Use the menu to navigate to my resume and other things I have built. Make sure to stop by the casino :D
        </p>
      </section>
    </main>
  );
}
